import { Component, OnInit, Input } from "@angular/core";
import { NzModalRef } from "ng-zorro-antd/modal";
import { HttpClient, HttpParams } from "@angular/common/http";

interface Notification {
  id: number;
  title: string;
  content: string;
  has_button: 0 | 1;
  button_title: string;
  button_action_type: ButtonAction;
  redirect_url: string;
  has_icon: boolean;
}

type ButtonAction = 0;

@Component({
  selector: "host-system-notification-dynamic",
  templateUrl: "./system-notification.component.html",
  styleUrls: ["./system-notification.component.scss"],
})
export class SystemNotificationComponent implements OnInit {
  _notification;

  @Input()
  get notification() {
    return this._notification;
  }
  set notification(value: Notification) {
    value.content = value.content.replace(/\n|\r|(\r\n)|\\n/g, "<br>");
    // .replace(/\n/g, '<br/>')
    // .replace(/\s/g, '&nbsp;');
    this._notification = value;
  }

  constructor(
    private http: HttpClient,
    private modalRef: NzModalRef,
  ) {}

  ngOnInit() {}

  onClickBtn() {
    if (this.notification.button_action_type === 0) {
      open(this.notification.redirect_url);
      this.report();
      this.modalRef.destroy();
    }
  }

  report() {
    const query = new HttpParams().append("id", `${this.notification.id}`);
    this.http.get("/api/pop_window/click", { params: query }).subscribe((res) => {});
  }
}
